import { createSlice } from "@reduxjs/toolkit";
import { employeeLevelsThunk, employeeModulesThunk, addEmployeeThunk, getEmployeeThunk, updateEmployeeThunk } from "./employeeThunk";

const initialState = {
    status: "idle",
    status1: "idle",
    error: null,
    success: "",
    employeeLevels: [],
    employeeModules: [],
    getEmployees: [],
};

const employeeSlice = createSlice({
    name: "employees",
    initialState,
    reducers: {
        resetEmployeeState: (state, action) => {
            state.status = "idle";
            state.status1 = "idle";
            state.error = null;
            state.success = "";
        }
    },
    extraReducers: (builder) => {
        builder
            // employeeLevelsThunk
            .addCase(employeeLevelsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(employeeLevelsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.employeeLevels = action.payload;
            })
            .addCase(employeeLevelsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })

            // employeeModulesThunk
            .addCase(employeeModulesThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(employeeModulesThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.employeeModules = action.payload;
            })
            .addCase(employeeModulesThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })

            //    addEmployeeThunk
            .addCase(addEmployeeThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addEmployeeThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(addEmployeeThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })

            //    getEmployeeThunk
            .addCase(getEmployeeThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getEmployeeThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.getEmployees = action.payload;
            })
            .addCase(getEmployeeThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })


            //   updateEmployeeThunk
            .addCase(updateEmployeeThunk.pending, (state) => {
                state.status1 = "loading";
                state.error = null;
            })
            .addCase(updateEmployeeThunk.fulfilled, (state, action) => {
                state.status1 = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(updateEmployeeThunk.rejected, (state, action) => {
                state.status1 = "failed";
                state.error = action.payload;
            })
    },
});

export const { resetEmployeeState } = employeeSlice.actions;
export default employeeSlice.reducer;
